import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const auth_apis = API_URLs.authentincation;

export const apiCall_login = async (phoneNumber) => {
  return http.post(auth_apis.login + "?Phonenumber=" + phoneNumber);
};

export const apiCall_checkLogin = async () => {
  return http.post(auth_apis.checkLogin);
};

export const apiCall_verify = async ({ phoneNumber, verifyCode }) => {
  return http.post(
    auth_apis.verify +
      `?PhoneNumber=${phoneNumber}&VerificationCode=${verifyCode}`
  );
};
